import NavItem from './NavItem';
import { useSelector } from 'react-redux';
import ArrowDownIcon from 'assets/icons/ArrowDown';
import { Avatar, Chip, Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
// import { useLocation } from "react-router-dom";

// project import
// import { activeItem } from "store/features/menu/menuSlice";

function NavCollapse({ item, level = 1, accessor, expandedKey, setExpandedKey = () => {} }) {
	// const dispatch = useDispatch();
	// const { pathname } = useLocation();
	const { drawerOpen, openItem } = useSelector((state) => state.menu);
	const navGroupKey = item?.displayName?.toLowerCase?.() ?? '';

	// console.log(itemIcon);

	// const activeBtnHandler = (id) => {
	//   const route = pathname.replace("/", "");
	//   if (openItem.findIndex((id) => id === route) > -1) {
	//     dispatch(activeItem({ openItem: [id, route] }));
	//   } else {
	//     dispatch(activeItem({ openItem: [id] }));
	//   }
	// };

	const clickHandler = () => {
		if (!navGroupKey) return;
		setExpandedKey((prev) => (prev === navGroupKey ? null : navGroupKey));
	};
	// console.log("Open Item", openItem);
	// console.log("pathName", pathName);

	const selectedItemParent = item?.children.find((child) => {
		const childDisplayName = child?.displayName?.toLowerCase?.();
		const openItemValue = openItem?.[0]?.toLowerCase?.();

		// Only replace "/" and "-" if openItem does not contain "In-progress"
		const formattedOpenItem = openItemValue === 'in-progress' ? openItemValue : openItemValue?.replace('/', '')?.replace('-', ' ');

		return childDisplayName === formattedOpenItem;
	});

	const parent = selectedItemParent ? navGroupKey : null;
	const isExpanded = expandedKey === navGroupKey;
	const isActiveParent = parent === navGroupKey;
	// const pathnameRoute = pathname.replace("/", "");
	// console.log("pathName", pathnameRoute);
	// const isSelected = openItem.findIndex((id) => id.toLowerCase() === pathnameRoute.toLowerCase()) > -1;
	const textColor = 'text.primary';
	// const iconSelectedColor = 'primary.main';
	const iconSelectedColor = '#0052CC';
	const hoverBg = '#F8FAFC';

	return (
		<>
			<ListItemButton
				disabled={item.disabled}
				onClick={clickHandler}
				sx={{
					borderRadius: '8px',
					px: 1.5,
					py: 1,
					gap: 1,
					'&:hover': { bgcolor: hoverBg },
				}}
			>
				{/* {(itemIcon || itemActiveIcon) && (
					<ListItemIcon
						sx={{
							minWidth: 28,
						}}
					>
						{parent === item?.displayName.toLowerCase() ? (
							<img src={itemActiveIcon} width={18} height={18} alt="lynorg" />
						) : (
							<img src={itemIcon} width={18} height={18} alt="lynorg" />
						)}
					</ListItemIcon>
				)} */}

				{(drawerOpen || (!drawerOpen && level !== 1)) && (
					<ListItemText
						sx={{ my: 0 }}
						primary={
							<Typography
								component="span"
								sx={{
									...(isActiveParent || isExpanded
										? { color: iconSelectedColor, fontWeight: 500 }
										: { color: textColor }),
									fontSize: '0.875rem',
								}}
							>
								{item[accessor]}
							</Typography>
						}
					/>
				)}
				{(drawerOpen || (!drawerOpen && level !== 1)) && item.chip && (
					<Chip
						color={item.chip.color}
						variant={item.chip.variant}
						size={item.chip.size}
						label={item.chip.label}
						avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
						sx={{
							height: 18,
							borderRadius: '999px',
							'& .MuiChip-label': { px: 1, fontSize: '0.625rem', fontWeight: 600 },
						}}
					/>
				)}
				<ListItemIcon
					sx={{
						'& svg': { stroke: isActiveParent || isExpanded ? iconSelectedColor : textColor },
					}}
				>
					{isExpanded ? (
						<ArrowDownIcon height="21px" style={{ rotate: '180deg' }} />
					) : (
						<ArrowDownIcon height="21px" />
					)}
				</ListItemIcon>
			</ListItemButton>
			<Collapse in={isExpanded} timeout="auto" sx={{ mt: 0.5 }}>
				<List disablePadding sx={{ display: 'flex', flexDirection: 'column', gap: '4px', pt: 0.5 }}>
					{[...(item?.children ?? [])]
						.sort((a, b) => a.serial - b.serial)
						.map((menuItem) => (
							<NavItem
								key={menuItem.id}
								item={menuItem}
								level={2}
								parentPath={navGroupKey}
								accessor={accessor}
								selectionVariant="dark"
								showIcon
							/>
						))}
				</List>
			</Collapse>
		</>
	);
}

export default NavCollapse;

// import { Avatar, Chip, Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
// import { useEffect, useMemo } from 'react';
// // import { useLocation } from "react-router-dom";
// import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import NavItem from './NavItem';
// import { useSelector } from 'react-redux';

// // project import
// // import { activeItem } from "store/features/menu/menuSlice";

// // assets
// /* eslint-disable-next-line */
// const menuIconPath = require.context('assets/images/menu-icons/', true);

// function NavCollapse({ item, level = 1, handleDrawerToggle, accessor, open, setOpen }) {
// 	// const dispatch = useDispatch();
// 	// console.log("open", open);
// 	// const { pathname } = useLocation();
// 	const { drawerOpen, openItem } = useSelector((state) => state.menu);
// 	const pathName = item.displayName && item.displayName.toLowerCase().replace(' ', '-');

// 	const itemIcon = useMemo(() => {
// 		try {
// 			return menuIconPath(`./${pathName}_green.svg`);
// 		} catch (error) {
// 			return false;
// 		}
// 		//eslint-disable-next-line
// 	}, []);

// 	// console.log(itemIcon);

// 	// const activeBtnHandler = (id) => {
// 	//   const route = pathname.replace("/", "");
// 	//   if (openItem.findIndex((id) => id === route) > -1) {
// 	//     dispatch(activeItem({ openItem: [id, route] }));
// 	//   } else {
// 	//     dispatch(activeItem({ openItem: [id] }));
// 	//   }
// 	// };

// 	const clickHandler = () => {
// 		setOpen((prev) => {
// 			let obj = {};
// 			Object.keys(prev).forEach((key) => {
// 				if (item?.displayName?.toLowerCase() === key) {
// 					obj[key] = !prev[key];
// 				} else {
// 					obj[key] = false;
// 				}
// 			});
// 			return obj;
// 		});
// 		// activeBtnHandler(pathName);
// 	};
// 	// console.log("Open Item", openItem);
// 	// console.log("pathName", pathName);

// 	const selectedItemParent = item?.children.find((child) => {
// 		const childDisplayName = child?.displayName.toLowerCase();
// 		const openItemValue = openItem[0]?.toLowerCase();

// 		// Only replace "/" and "-" if openItem does not contain "In-progress"
// 		const formattedOpenItem = openItemValue === 'in-progress' ? openItemValue : openItemValue?.replace('/', '')?.replace('-', ' ');

// 		return childDisplayName === formattedOpenItem;
// 	});
// 	let parent = null;
// 	if (selectedItemParent) {
// 		parent = item?.displayName?.toLowerCase();
// 	}
// 	// console.log("parent", parent);
// 	// const pathnameRoute = pathname.replace("/", "");
// 	// console.log("pathName", pathnameRoute);
// 	// const isSelected = openItem.findIndex((id) => id.toLowerCase() === pathnameRoute.toLowerCase()) > -1;
// 	const textColor = 'text.primary';
// 	const iconSelectedColor = 'primary.main';

// 	useEffect(() => {
// 		// if (parent) {
// 		const navGroupName = item?.displayName?.toLowerCase();

// 		setOpen((prev) => {
// 			const newOpenState = { ...prev };

// 			// Set previous states to false if parent is not "worklist"
// 			Object.keys(prev).forEach((key) => {
// 				if (parent && parent !== 'worklist' && key !== parent) {
// 					newOpenState[key] = false;
// 				}
// 			});

// 			// Open the current navGroupName based on parent condition
// 			newOpenState[navGroupName] = parent ? navGroupName === parent : navGroupName === 'worklist';

// 			return newOpenState;
// 		});
// 		// }
// 	}, [parent]);

// 	return (
// 		<>
// 			<ListItemButton
// 				disabled={item.disabled}
// 				onClick={clickHandler}
// 				sx={{
// 					// zIndex: 1201,
// 					pl: drawerOpen ? `${level * 28}px` : 1.5,
// 					py: !drawerOpen && level === 1 ? 1.25 : 1,
// 					...(drawerOpen && {
// 						'&:hover': {
// 							bgcolor: 'common.white',
// 						},
// 					}),
// 					...(!drawerOpen && {
// 						'&:hover': {
// 							bgcolor: 'common.white',
// 						},
// 					}),
// 				}}
// 			>
// 				{itemIcon && (
// 					<ListItemIcon
// 						sx={{
// 							minWidth: 28,
// 						}}
// 					>
// 						<img src={itemIcon} width={16} height={16} alt="lynorg" />
// 					</ListItemIcon>
// 				)}
// 				{(drawerOpen || (!drawerOpen && level !== 1)) && (
// 					<ListItemText
// 						primary={
// 							<Typography variant="h6" sx={{ color: parent === item?.displayName.toLowerCase() ? iconSelectedColor : textColor }}>
// 								{item[accessor]}
// 							</Typography>
// 						}
// 					/>
// 				)}
// 				{(drawerOpen || (!drawerOpen && level !== 1)) && item.chip && (
// 					<Chip
// 						color={item.chip.color}
// 						variant={item.chip.variant}
// 						size={item.chip.size}
// 						label={item.chip.label}
// 						avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
// 					/>
// 				)}
// 				<ListItemIcon
// 					sx={{
// 						minWidth: 28,
// 						color: parent === item?.displayName.toLowerCase() ? iconSelectedColor : textColor,
// 					}}
// 				>
// 					{open?.[item?.displayName?.toLowerCase()] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
// 				</ListItemIcon>
// 			</ListItemButton>
// 			<Collapse in={open?.[item?.displayName?.toLowerCase()]} timeout="auto">
// 				<List>
// 					{[...(item?.children ?? [])]
// 						.sort((a, b) => a.serial - b.serial)
// 						.map((menuItem) => (
// 							<li key={menuItem.id}>
// 								<NavItem
// 									item={menuItem}
// 									level={2}
// 									handleDrawerToggle={handleDrawerToggle}
// 									parentPath={pathName}
// 									accessor={accessor}
// 								/>
// 							</li>
// 						))}
// 				</List>
// 			</Collapse>
// 		</>
// 	);
// }

// export default NavCollapse;
